export default __webpack_public_path__ + "static/media/lock.ff8c4bd1.svg";